<script lang="ts">
	import type { MainPoiCategory, PoiImages } from '$lib/components/pois/types';
	import defaultPoiImage from '$assets/pois/default.webp';
	import ArrivalZoiBackground from '$assets/zoi/arrival-zoi-background.webp';
	import ZoiBackgroundWithEv from '$assets/zoi/zoi-background-ev.webp';
	import ZoiBackground from '$assets/zoi/zoi-background.webp';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import SkeletonButton from '$lib/components/atoms/skeleton/SkeletonButton.svelte';
	import * as m from '$paraglide/messages';
	import { createEventDispatcher } from 'svelte';

	export let images: PoiImages | undefined = undefined;
	export let category: MainPoiCategory = 'TOURISM';
	export let isLoading = false;
	export let containsEv = false;
	export let dataTestId = 'zoi-card';

	const dispatch = createEventDispatcher<{ selectZoi: void }>();

	$: backgroundImage
		= category === 'ACCOMMODATION'
			? ArrivalZoiBackground
			: containsEv
			? ZoiBackgroundWithEv
			: ZoiBackground;

	const zoiCardClasses
		= 'bg-center bg-cover bg-neutral-soft w-50 h-50 rd-t-4 flex items-center justify-center max-w-full';
</script>

<div
	class="bg-neutral-weakest rd-4 border-neutral-soft border-1 border-solid shadow-smooth-bottom-1 w-50"
	data-testid={dataTestId}
>
	{#if isLoading}
		<div class={zoiCardClasses}>
			<div class="h-39 w-39 rd-full bg-neutral" />
		</div>
		<div class="p-2 flex justify-center">
			<SkeletonButton text={m.zoi_card__see_on_map()} />
		</div>
	{:else}
		<div style="background-image: url('{backgroundImage}')" class={zoiCardClasses}>
			<Image
				src={images?.w320 ?? defaultPoiImage}
				alt={m.zoi_card__image_alt()}
				class="rd-full w-25 h-25 border-4 border-solid border-neutral-weakest shadow-drop"
			/>
		</div>
		<div class="p-2 flex justify-center">
			<Button
				color="light"
				text={m.zoi_card__see_on_map()}
				onclick={() => dispatch('selectZoi')}
				icon="zoom-in"
			/>
		</div>
	{/if}
</div>
